let telegramWebAppScriptPromise = null;

/** True inside Telegram Mini App / Telegram WebView (not a normal browser tab). */
export function isTelegramRuntime() {
  if (typeof window === "undefined") return false;
  if (window.Telegram?.WebApp || window.TelegramWebviewProxy) return true;
  return /tgWebApp/i.test(window.location.search);
}

/**
 * Loads telegram-web-app.js once. Telegram may inject WebApp already; otherwise the script
 * bridges TelegramWebviewProxy → window.Telegram.WebApp (and populates initData).
 */
export function ensureTelegramWebAppScript() {
  if (typeof window === "undefined") return Promise.resolve(false);
  if (window.Telegram?.WebApp) return Promise.resolve(true);
  if (telegramWebAppScriptPromise) return telegramWebAppScriptPromise;

  telegramWebAppScriptPromise = new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = "https://telegram.org/js/telegram-web-app.js";
    script.async = true;
    script.onload = () => resolve(Boolean(window.Telegram?.WebApp));
    script.onerror = () => resolve(false);
    document.head.appendChild(script);
  });

  return telegramWebAppScriptPromise;
}

/**
 * Wait until Mini App initData is available (script load + short poll). Outside Telegram
 * returns immediately with whatever is present (usually empty).
 */
export async function resolveTelegramInitData({ timeoutMs = 2500 } = {}) {
  if (typeof window === "undefined") return "";

  if (!isTelegramRuntime()) {
    return String(window.Telegram?.WebApp?.initData || "").trim();
  }

  await ensureTelegramWebAppScript();

  const deadline = Date.now() + timeoutMs;
  for (;;) {
    const init = String(window.Telegram?.WebApp?.initData || "").trim();
    if (init) return init;
    if (Date.now() >= deadline) return "";
    await new Promise((resolve) => setTimeout(resolve, 50));
  }
}
